<template>
  <div v-if="carsLoaded">
    <car-heading></car-heading>
    <div
      class="row"
      v-if="car"
    >
      <div class="col-12 mb-2 mb-md-4">
        <h3 class="mb-2">Arvoisa Asiakkaamme,</h3>
        <p>Uusi {{template.customer_name}} -autonne sisältää lukuisia ominaisuuksia, jotka voidaan säätää mieleiseksenne. Osan asetuksista voitte jatkossa tehdä myös itse, osa on tehtävissä Toyota-liikkeessä. Mieleisenne valinnat voidaan asettaa Toyota-mekaanikon toimesta jo ajoneuvon luovutuksen yhteydessä.</p>

        <p>Käytettävissä olevat asetukset vaihtelevat ajoneuvonne varustetason mukaan. Voitte halutessanne kysyä lisätietoja teitä palvelevan Toyota-liikkeen automyyjiltä tai huoltoneuvojilta.</p>

        <p>Valintojen ilmoittaminen ei ole pakollista ja mikäli ette täytä tätä lomaketta, niin ajoneuvo luovutetaan oletusvalinnoilla. Mikäli päädytte ilmoittamaan omat valintanne, suosittelemme palauttamaan lomakkeen välittömästi, mutta kuitenkin viimeistään 2 arkipäivää ennen jälleenmyyjän kanssa erikseen sopimaanne auton luovutuspäivämäärää. Jos tämä ei enää ole mahdollista, niin sovi jälleenmyyjäsi kanssa erikseen, mikäli personointi on vielä mahdollista.</p>
      </div>
    </div>
    <form-head :disabled="withOrder"></form-head>
    <p class="support-text mb-2 mb-md-4">Huomaathan, että valintojesi täyttämisen nopeuttamiseksi olemme jo esitäyttäneet oletusvalinnat, jotka voit jättää valituiksi tai vaihtaa haluamaksesi.</p>
    <h2 class="mb-1 mb-md-3">Omat valintani</h2>
    <div v-if="data">
      <form-component
        :data="data"
        v-if="formLoaded"
      ></form-component>
    </div>
    <p v-else>Personointitietoja ei löytynyt valitsemallesi autolle.</p>
    <p class="support-text my-2">Autoosi saatavilla olevat toiminnot voivat vaihdella malliversiosta riippuen. Toyota Auto Finland Oy pidättää oikeuden muutoksiin.</p>
    <div class="mb-4">
      <button
        class="btn btn-t1-primary"
        type="button"
        @click="showSummary()"
      >Siirry yhteenvetosivulle</button>
    </div>
  </div>
</template>

<script>
/**
 * Car view
 */
import { mapGetters } from "vuex";
import CarHeading from "../components/CarHeading";
const Form = () => import(/* webpackChunkName: "form" */ "../components/Form");
const FormHead = () =>
  import(/* webpackChunkName: "form" */ "../components/FormHead");
import Bus from "../bus";
export default {
  /**
   * @description
   * @returns {Object}
   */
  data() {
    return {
      image: "",
      imgLoaded: false
    };
  },
  computed: {
    ...mapGetters({
      getTemplateByKey: "getTemplateByKey",
      getTemplateById: "getTemplateById",
      getCarByKey: "getCarByKey",
      formLoaded: "formLoaded",
      withOrder: "withOrder",
      getForm: "getForm",
      getDefaults: "getDefaults",
      formChanged: "formChanged",
      carsLoaded: "carsLoaded"
    }),
    /**
     * @description Get car by key
     * @returns {Object}
     */
    car() {
      let car = this.getCarByKey(this.$route.params.car);
      if (car === undefined) {
        //eslint-disable-next-line
        this.$router.push("/404");
      } else {
        return car;
      }
    },
    /**
     * @description Get template by key
     * @returns {Object}
     */
    template() {
      return this.getTemplateById(this.car.template_id);
    },
    /**
     * @description Parse template data
     * @returns {Object}
     */
    data() {
      if (this.template) {
        let data = JSON.parse(this.template.data);
        return data;
      }
      return {};
    },
    checkChanged() {
      let choises = this.getForm.choises;
      let defaults = this.getDefaults;
      let value = false;
      window._.each(choises, (v, k) => {
        if (choises[k] === null) {
          choises[k] = undefined;
        }
        if (typeof choises[k] === "object") {
          if ("id" in choises[k]) {
            if (!window._.isEqual(defaults[k]["id"], choises[k]["id"])) {
              value = true;
            }
          } else {
            window._.each(choises[k], (val, key) => {
              if (!window._.isEqual(defaults[k][key], val)) {
                value = true;
              }
            });
          }
        } else {
          if (!window._.isEqual(defaults[k], v)) {
            value = true;
          }
        }
      });
      return value;
    }
  },
  methods: {
    showSummary() {
      if (this.checkChanged) {
        this.$router.push("/" + this.$route.params.car + "/yhteenveto");
      } else {
        Bus.$emit("onlyDefaults");
      }
    },
    createdCb() {
      if (Object.keys(this.$store.state.form.form.choises).length !== 0) {
        this.$store.dispatch("formLoaded");
      } else {
        this.$store.dispatch("hydrateChoises", this.data.elements);
      }
    }
  },
  /**
   * @description
   */
  created() {
    this.$watch("carsLoaded", (val, old) => {
      if (val) {
        this.createdCb();
      }
    });
    if (this.carsLoaded) {
      this.createdCb();
    }
  },
  mounted() {
    // window.ga("set", "page", '/form');
    // window.ga("send", "pageview");
  },
  components: {
    FormComponent: Form,
    FormHead,
    CarHeading
  }
};
</script>

<style lang="scss">
.v-select {
  background: #f0f0f0;

  .dropdown-toggle {
    border: 0;
    &:after {
      visibility: hidden;
    }
  }

  .open-indicator:before {
    border-color: #e50000;
  }
}
.image {
  max-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  img {
    max-width: 100%;
    max-height: 100%;
    height: 300px;
  }
}
</style>
